
class LaunchScreenViewController extends MUIViewController
{
    viewDidLoad(){
        super.viewDidLoad();
    }

}
